import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import {
  Router,
} from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/shared/services/common.service";
import { CouponesService } from "src/app/shared/services/coupones.service";
import { UserService } from "src/app/shared/services/user.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-my-coupones",
  templateUrl: "./my-coupones.component.html",
  styleUrls: ["./my-coupones.component.scss"],
})
export class MyCouponesComponent implements OnInit {
  userLogedIn: boolean = false;
  currentUser: any;
  user_img = "";
  existImg: boolean = false;
  usre_id: any;
  user_name = "";
  email = "";
  brief = "";
  mobile = "";
  address = "";
  password = "";
  public errorOccurred = false;
  public errorOccurredMessage = "";
  page_name =
    localStorage.getItem("front-lang") == "ar" ? "كوبوناتي" : "My Coupons";
  successMobile: boolean = false;
  successUser_name: boolean = false;
  successEmail: boolean = false;
  public openDashboard: boolean = false;
  public errorSuccessEmailMessage = "";

  public errorUserNameMessage = "";

  errorMobileMessage = "";
  successPassword: boolean = false;
  errorPasswordMessage = "";

  usedCouponesActive: boolean = false;

  activeCouponesList: any[] = [];
  usedCouponesList: any[] = [];
  finished: boolean = false;
  currentUrl: string = "";
  hostName: string = "";
  couponCode: string = "";

  constructor(
    private user: UserService,
    private coomenservice: CommonService,
    private router: Router,
    private couponesService: CouponesService
  ) {
    // SET TITLE
    this.coomenservice.setTitle(this.page_name);
  }

  ngOnInit(): void {
    this.checkOuth();
    this.getCouponsListAll();
    this.getCouponsListUsed();

    this.hostName = this.coomenservice.getDomainFromUrl();
    this.currentUrl = `https://${this.hostName}/pages/my-coupones`;
  }

  getCouponsListAll() {
    this.finished = false;
    this.couponesService.getCouponsList("all").subscribe((data) => {
      this.finished = true;
      if (data.success) {
        this.activeCouponesList = data.data;
        // console.log("All Coupones", this.activeCouponesList);
      } else {
        // console.log("Error Loading Coupones");
      }
    });
  }
  getCouponsListUsed() {
    this.finished = false;
    this.couponesService.getCouponsList("used").subscribe((data) => {
      this.finished = true;
      // console.log("used Couponessss", data);
      if (data.success) {
        this.usedCouponesList = data.data;
        console.log(this.usedCouponesList);
        // console.log("used Coupones", this.usedCouponesList);
      } else {
        // console.log("Error Loading Coupones");
      }
    });
  }

  loginclicked: boolean = false;

  // goToLogin() {
  //   this.loginclicked = true;
  // }
  // close() {
  //   this.loginclicked = false;
  // }

  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_name = this.currentUser.user_name;
      this.email = this.currentUser.email;
      this.brief = this.currentUser.brief;
      this.address = this.currentUser.address;
      this.mobile = this.currentUser.mobile;
    } else {
      this.userLogedIn = false;
      this.currentUser = null;
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
      // this.router.navigate(["/pages/login"]);
      this.goToLogin();
    }
  }
  userLogOut() {
    localStorage.removeItem("currentUserFront");
    localStorage.removeItem("clientToken");
    this.userLogedIn = false;
    this.currentUser = [];
    this.usre_id = "";
    this.user_img = "";
    this.user.logout();
    // this.router.navigate(["/pages/login"]);

    this.coomenservice.UpdatedSetting.next("logout");
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
    // this.goToLogin();
  }
  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }

  applyCoupon(couponCode: string): void {
    console.log("Coupon Code:", couponCode);
    const data = {
      code: couponCode,
    };
    this.couponesService.reserveCouponCodeByClient(data).subscribe((data) => {
      if (data.success) {
        this.activeCouponesList.unshift(data.data);
        Swal.fire({
          title: localStorage.getItem("front-lang") == "ar" ? "تطبيق" : "Apply",
          text: data.message,
          icon: "success",
          customClass: {
            title: "swal-title-center",
          },
        });
        this.couponCode = ""
      } else {
        this.couponCode = "";
        Swal.fire({
          title: localStorage.getItem("front-lang") == "ar" ? "خطأ" : "Error",
          text: data.message,
          icon: "error",
          customClass: {
            title: "swal-title-center",
          },
        });
      }
    });
  }
}
